<div class="inputGrid w-full">
    <app-input-fulltext
        [form]="form"
        [options]="store.anamneses()"
        (selectedOptionChange)="selectedAnamnesisChange($event)"
    ></app-input-fulltext>
    <app-button
        [disabled]="!isAllowed['folderRecord.create']()"
        (clickEvent)="save()"
        [loading]="store.loadingAny() || doctorInput.store.loadingAny()"
        icon="pi-save"
        label="database.persons.saveButton"
        class="white-space-nowrap"
    ></app-button>
    <app-button
        icon="pi-print"
        severity="secondary"
        label="database.persons.printButton"
        class="white-space-nowrap"
        (clickEvent)="print()"
    ></app-button>

    <div class="formGrid gap-large left-container">
        <app-diagnosis-select-input
            class="fr-2"
            [form]="form"
            id="secondaryDiagnoses"
            [multiselect]="true"
            label="anamnesis.fields.secondaryDiagnoses"
        ></app-diagnosis-select-input>
        <app-diagnosis-select-input
            [form]="form"
            label="anamnesis.fields.diagnosis"
        ></app-diagnosis-select-input>
        <div class="flex gap-small">
            <app-service-doctor-select-input
                #doctorInput
                class="flex-1"
                [form]="form"
            ></app-service-doctor-select-input>
            @if (folderStore.canEdit() && isAllowed['folderRecord.create']()) {
                <app-button
                    icon="pi-plus"
                    [pTooltip]="'common.addDoctorButtonTooltip' | translate"
                    (clickEvent)="addNewDoctor()"
                ></app-button>
            }
        </div>

        <app-insurance-company-select-input
            id="insuranceAbbr"
            [form]="form"
            label="anamnesis.fields.insuranceAbbr">
        </app-insurance-company-select-input>

        <app-select-input
            id="bloodType"
            [form]="form"
            label="enum.bloodType.label"
            [staticOptions]="bloodTypeEnumOptions"
            valueKey="value">
        </app-select-input>

        <div class="fr-2 fh-2 flex-column gap-small align-items-start">
            @if (store.showHbsagInput()) {
                <app-check-input [form]="form" class="w-full" id="isHbsag" [prefix]="prefix"></app-check-input>
            }
            @if (store.showHivInput()) {
                <app-check-input [form]="form" class="w-full" id="isHiv" [prefix]="prefix"></app-check-input>
            }
            @if (store.showRwInput()) {
                <app-check-input [form]="form" class="w-full" id="isRwe" [prefix]="prefix"></app-check-input>
            }
        </div>

        <app-date-input [form]="form" id="dateFrom" [prefix]="prefix"></app-date-input>
        <app-date-input [form]="form" id="dateTo" [prefix]="prefix"></app-date-input>

        @if (store.folder() && store.serviceId()) {
            <app-service-pattern-wysiwyg
                class="fr-2"
                [form]="form"
                id="anamnesis"
                editorKey="FolderAnamnesisAnamnesis"
                [placeholder]="'anamnesis.fields.anamnesis'"
                [height]="undefined"
                [personId]="store.folder()!.person.id"
                [serviceId]="store.serviceId()"
                [usage]="ServicePatternStructureUsageEnum.ANAMNESIS"
                (addedPattern)="formAddText(form, 'anamnesis', $event.content)"
                [patternGroups]="wysiwygPatterGroupsMedicalFolder"
            ></app-service-pattern-wysiwyg>
        }

        @defer (on viewport) {
            <app-input-wysiwyg
                class="fr-2"
                [form]="form"
                id="socialAnamnesis"
                [height]="undefined"
                editorKey="FolderAnamnesisSocialAnamnesis"
                [placeholder]="'anamnesis.fields.socialAnamnesis'"
                [autocompleteOrganization]="true"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="fr-2 anamnesis-editor-placeholder"></div>
        }

        @defer (on viewport) {
            <app-input-wysiwyg
                class="fr-2"
                [form]="form"
                id="nurseRecommendations"
                [height]="undefined"
                editorKey="FolderAnamnesisNurseRecommendations"
                [placeholder]="'anamnesis.fields.nurseRecommendations'"
                [autocompleteOrganization]="true"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="fr-2 anamnesis-editor-placeholder"></div>
        }

        @defer (on viewport) {
            <app-input-wysiwyg
                class="fr-2"
                [form]="form"
                id="statusPraesens"
                [height]="undefined"
                editorKey="FolderAnamnesisStatusPraesens"
                [placeholder]="'anamnesis.fields.statusPraesens'"
                [autocompleteOrganization]="true"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="fr-2 anamnesis-editor-placeholder"></div>
        }

        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="warning"
                [placeholder]="'anamnesis.fields.warning'"
                editorKey="FolderAnamnesisWarning"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }
        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="vaccine"
                [placeholder]="'anamnesis.fields.vaccine'"
                editorKey="FolderAnamnesisVaccine"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }
        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="implants"
                [placeholder]="'anamnesis.fields.implants'"
                editorKey="FolderAnamnesisImplants"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }
        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="medication"
                [placeholder]="'anamnesis.fields.medication'"
                editorKey="FolderAnamnesisMedication"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }

        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="operation"
                [placeholder]="'anamnesis.fields.operation'"
                editorKey="FolderAnamnesisOperation"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }
        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="invasives"
                [placeholder]="'anamnesis.fields.invasives'"
                editorKey="FolderAnamnesisInvasives"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }
        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="alergies"
                [placeholder]="'anamnesis.fields.alergies'"
                editorKey="FolderAnamnesisAlergies"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }
        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="wishes"
                [placeholder]="'anamnesis.fields.wishes'"
                editorKey="FolderAnamnesisWishes"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }

        @defer (on viewport) {
            <app-input-wysiwyg
                class="fr-3"
                [form]="form"
                id="note"
                [placeholder]="'anamnesis.fields.note'"
                editorKey="FolderAnamnesisNote"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="fr-3 anamnesis-editor-placeholder"></div>
        }
        @defer (on viewport) {
            <app-input-wysiwyg
                [form]="form"
                id="importantNote"
                [placeholder]="'anamnesis.fields.importantNote'"
                editorKey="FolderAnamnesisImportantNote"
                [autocompleteOrganization]="true"
                [height]="undefined"
            ></app-input-wysiwyg>
        } @placeholder {
            <div class="anamnesis-editor-placeholder"></div>
        }
    </div>

    <p-listbox class="fr-2"
        [options]="store.anamneses()"
        [(ngModel)]="selectedAnamnesis"
        (onChange)="listChange($event)"
        [filter]="true"
        [filterPlaceHolder]="'database.persons.history' | translate"
        optionLabel="createdAt"
        dataKey="index"
        styleClass="h-full"
        scrollHeight="calc(100vh - 20rem)"
        [emptyMessage]="'inputs.noResultsFound' | translate"
    >
        <ng-template pTemplate="itemx" let-item>
            <div (contextmenu)="rightClick(contextMenu, $event, item)" class="w-full">
                <div class="flex-column gap-x-small">
                    <div>{{ item.createdAt }}</div>
                    @if (item.user) {
                        <app-user-chip [user]="item.user"></app-user-chip>
                    }
                </div>
            </div>
        </ng-template>
    </p-listbox>
</div>

<p-contextMenu #contextMenu [model]="contextMenuItems"></p-contextMenu>
